import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api, brl } from "@/lib/api";
import { useAdminTheme } from "./AdminLayout";
import { FilterBar, useAdminFilters, cityParam } from "./filters";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function AdminStores() {
  const { accent } = useAdminTheme();
  const f = useAdminFilters();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/admin/stores", { params: { city_id: cityParam(f) } }).then(({ data }) => setRows(data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [f.cityId]);

  return (
    <div data-testid="admin-stores">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="font-display text-3xl font-extrabold">Gestão de lojistas</h1>
          <p className="text-sm text-gray-500">{rows.length} lojas cadastradas</p>
        </div>
        <FilterBar f={f} accent={accent} />
      </div>

      <div className="rounded-2xl border border-gray-200 bg-white mt-6 overflow-x-auto">
        <Table data-testid="stores-table">
          <TableHeader>
            <TableRow>
              <TableHead>Loja</TableHead>
              <TableHead>Categoria</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Nota</TableHead>
              <TableHead className="text-right">Pedidos</TableHead>
              <TableHead className="text-right">Volume de vendas</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((s) => (
              <TableRow key={s.id} data-testid={`store-row-${s.name}`}>
                <TableCell className="font-semibold">
                  <div className="flex items-center gap-2">
                    <img src={s.logo_url} alt={s.name} className="w-9 h-9 rounded-lg object-cover" />
                    {s.name}
                  </div>
                </TableCell>
                <TableCell className="text-gray-600">{s.category}</TableCell>
                <TableCell>
                  <span
                    className="text-[10px] font-bold px-2 py-1 rounded-full text-white"
                    style={{ background: s.status === "ativo" ? "#2E8B57" : "#F5C518" }}
                  >
                    {s.status === "ativo" ? "ATIVO" : "PENDENTE"}
                  </span>
                </TableCell>
                <TableCell>
                  <span className="flex items-center gap-1 text-sm font-bold">
                    <Star size={12} fill="#F5C518" stroke="none" /> {s.rating.toFixed(1).replace(".", ",")}
                  </span>
                </TableCell>
                <TableCell className="text-right">{s.orders_count}</TableCell>
                <TableCell className="text-right font-display font-extrabold">{brl(s.sales_volume)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
